import React from "react";
import { motion } from "framer-motion";

export const DashboardCard = ({
  children,
  title,
  subtitle,
  action,
  style,
  theme,
  itemVariants,
}) => (
  <motion.div
    variants={itemVariants}
    whileHover={{ y: -4, boxShadow: theme?.shadowHover }}
    style={{
      background: theme?.surface,
      borderRadius: "16px",
      boxShadow: theme?.shadow,
      border: `1px solid ${theme?.border}`,
      padding: "24px",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      transition: "box-shadow 0.25s ease, transform 0.25s ease",
      ...style,
    }}
  >
    {(title || subtitle || action) && (
      <div className="d-flex justify-content-between align-items-start mb-4 ">
        <div>
          {title && (
            <h3
              style={{
                margin: 0,
                fontSize: "1.1rem",
                fontWeight: "700",
                color: theme?.textPrimary,
              }}
            >
              {title}
            </h3>
          )}
          {subtitle && (
            <p style={{ margin: "4px 0 0", fontSize: "0.8rem", color: theme?.textSecondary }}>
              {subtitle}
            </p>
          )}
        </div>
        {action && <div>{action}</div>}
      </div>
    )}
    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>{children}</div>
  </motion.div>
);

const KPICard = ({
  loading,
  title,
  value,
  subtitle,
  icon: Icon,
  themeColor,
  themeBgColor,
  valueColor,
  subtitleColor,
  itemVariants,
  SkeletonComponent,
}) => {
  if (loading && SkeletonComponent) {
    return <SkeletonComponent />;
  }

  return (
    <motion.div variants={itemVariants} className="dashboard-kpi-card">
      <div className="dashboard-kpi-header">
        <span className="dashboard-kpi-title">{title}</span>
        <div
          className="dashboard-kpi-icon-wrapper"
          style={{ background: themeBgColor, color: themeColor }}
        >
          {Icon && <Icon size={18} />}
        </div>
      </div>
      <h5 className="dashboard-kpi-value" style={{ color: valueColor || "#1e293b" }}>
        {value}
      </h5>
      <div className="dashboard-kpi-subtitle-wrapper" style={{ color: subtitleColor || "#64748b" }}>
        <span>{subtitle}</span>
      </div>
    </motion.div>
  );
};

export default KPICard;
